import { render, staticRenderFns } from "./PaymentLinkClearSale.vue?vue&type=template&id=75b4870d&scoped=true&"
import script from "./PaymentLinkClearSale.vue?vue&type=script&lang=js&"
export * from "./PaymentLinkClearSale.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLinkClearSale.vue?vue&type=style&index=0&id=75b4870d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b4870d",
  null
  
)

export default component.exports